<template>
    <div>
        <loading-custom :loading="loading" />
        <!-- Trigger Button -->
        <div class="d-flex justify-content-end">
            <button
                type="button"
                class="btn btn-sm btn-danger mr-2 mb-2"
                data-toggle="modal"
                :data-target="'#deleteCategory' + this.category.id"
            >
                <i class="fa fa-trash"></i>
                ลบ
            </button>
        </div>

        <!-- Modal -->
        <div
            class="modal"
            :id="'deleteCategory' + this.category.id"
            tabindex="-1"
            role="dialog"
            data-backdrop="static"
            data-keyboard="false"
        >
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-light">
                        <h5 class="tw-font-bold">
                            ลบหมวดหมู่ {{ this.category.title }}
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body tw-flex tw-justify-center">
                        <div class="grid-cols-1">
                            <div class="tw-flex tw-justify-center">
                                <i
                                    :class="'fa ' + this.category.icon"
                                    class="fa-3x"
                                ></i>
                            </div>
                            <div class="mt-2">
                                <p class="text-secondary">
                                    คุณต้องการลบหมวดหมู่
                                    <strong class="text-danger">{{ this.category.title }}</strong>
                                    ใช่หรือไม่?
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-4">
                        <button
                            type="button"
                            data-dismiss="modal"
                            class="btn btn-danger w-100"
                            @click="deleteCategory()"
                        >
                            ยืนยันลบ
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import icons from "./icons.json";

export default {
    props: ["shop", "category"],
    data() {
        return {
            loading: false,
            icons: icons
        };
    },
    watch: {},
    methods: {
        onUpdate() {
            this.$emit("onUpdate", "success");
        },
        async deleteCategory() {
            this.loading = true;

            await axios
                .delete(`/backend/s/${this.shop}/categories/${this.category.id}`)
                .then(res => {
                    if (res.data.status == "success") {
                        this.onUpdate();
                    } else if (res.data.status == "error") {
                        this.$swal({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: res.data.message,
                            showConfirmButton: true
                        });
                    }
                    this.loading = false;
                })
                .catch(err => {
                    this.messageAlert("error", "Sorry", err);
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.active {
    border: 4px solid red;
}

.square {
    width: 50pt;
    height: 50pt;
}
</style>
